<template>
    <v-container fluid class="pa-0">
    <v-row class="align-stretch justify-start">
      <v-col cols="12" md="8" class="pa-2 pt-0" v-if="currentUser.team && currentUser.team.teamId">
        <TeamWidget :teamId="currentUser.team.teamId"></TeamWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2 pt-0" v-if="currentUser.team && currentUser.team.teamId && currentUser.team.seasonId">
        <NextGameWidget :teamId="currentUser.team.teamId" :seasonId="currentUser.team.seasonId"></NextGameWidget>
      </v-col>
      <!--Hub-->
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_DRIBLAB_HUB')">
        <LastScoutingAnalysesWidget></LastScoutingAnalysesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2" v-if="userHasRole('ROLE_DRIBLAB_HUB')">
        <ScoutingTasksWidget></ScoutingTasksWidget>
      </v-col>
      <!--Capture-->
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_VIDEO')">
        <UploadedGamesWidget></UploadedGamesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2" v-if="userHasRole('ROLE_VIDEO')">
        <CapturePlaylistsWidget></CapturePlaylistsWidget>
      </v-col>
      <v-col cols="12" class="pa-2" v-if="userHasRole('ROLE_EVENTING_DATA') && (currentUser.team && currentUser.team.teamId)">
        <LastGameWidget 
          :teamId="currentUser.team.teamId" 
          :xgMap="$vuetify.breakpoint.mdAndUp" 
          :showAllStats="$vuetify.breakpoint.mdAndUp"
        ></LastGameWidget>
      </v-col>
      <v-col cols="12" class="pa-2" v-if="userHasRole('ROLE_EVENTING_DATA')">
        <ChartsWidget
          class="elevation-2"
          :slides="['npgVsXGChart','xGAgainstvsNPGAgainstChart','xGvsxGAgainstChart']"
        ></ChartsWidget>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TeamWidget from "./widgets/TeamWidget";
import LastGameWidget from "./widgets/LastGameWidget";
import NextGameWidget from "./widgets/NextGameWidget";
import ChartsWidget from "./widgets/ChartsWidget";
import { userHasRole } from "../../utils/functions";
import LastScoutingAnalysesWidget from "./widgets/LastScoutingAnalysesWidget.vue";
import ScoutingTasksWidget from "./widgets/ScoutingTasksWidget.vue";
import UploadedGamesWidget from "./widgets/UploadedGamesWidget.vue";
import CapturePlaylistsWidget from "./widgets/CapturePlaylistsWidget.vue";

export default {
  name: "CoachDashboard",
  props: {},
  components: {
    TeamWidget,
    LastGameWidget,
    NextGameWidget,
    ChartsWidget,
    LastScoutingAnalysesWidget,
    ScoutingTasksWidget,
    UploadedGamesWidget,
    CapturePlaylistsWidget
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    this.loadViewData();
  },
  methods: {
    loadViewData() {},
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
  }
};
</script>
